import React from 'react';

import s from './style.module.scss';

const GlobalLoader = () => <div className={s.loader} />;

export default GlobalLoader;
